import { ppData } from '../configs/ppData.config';
import { useMemo } from 'react';
import { getFilteredListOfOptionValues } from '../utils/getFilteredListOfOptionValues';
export const useActiveListOfOptionValues = (searchParams, values, index) => {
    const dependencyValue = index > 0
        ? searchParams.get(ppData.options[index - 1].searchParamKey)
        : null;
    return useMemo(() => {
        return index > 0
            ? getFilteredListOfOptionValues(values, dependencyValue)
            : [...values];
    }, [dependencyValue]);
};
